import Vue from 'vue';
import VJsoneditor from 'v-jsoneditor/src/index';

Vue.use(VJsoneditor);
